import './polyfill';
import './initSentry';
import './i18n';

import { enableES5 } from 'immer';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import App from './App';
import reportWebVitals from './reportWebVitals';

// We support IE11 thus need to enable ES5 support in immer
enableES5();

const root = document.getElementById('root');

Modal.setAppElement(root!);

ReactDOM.render(<App />, root);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
